import styled from 'styled-components';

const Content = styled.div`
  font-size: 16px;
  color: #333;
  background-color: #fff;
  padding: 0px !important;
  margin: 0;
  background: #FFFFFF;
  font-family: 'Roboto', sans-serif!important;
  -webkit-font-smoothing: antialiased;
`;

export default Content;